export default __webpack_public_path__ + "static/media/error500.bcc22d02.png";